export default function getIdentificationCheckOutcomeDescription(
  isVerified: boolean | null
): 'Pass' | 'Fail' {
  return isVerified ? 'Pass' : 'Fail';
}
